import { fetchEventSource } from '@microsoft/fetch-event-source';
import { downloadCsv } from './api';
import fileDownload from 'js-file-download';

const generateCsv = async (url, token, body, onSuccess, onError) => {
  await fetchEventSource(url, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'application/json'
    },
    method: body === null ? 'GET' : 'POST',
    body: body === null ? null : JSON.stringify(body),
    async onmessage(ev) {
      try {
        const data = await downloadCsv(ev.data, token);
        fileDownload(data.data, ev.data ?? 'download.csv');
        onSuccess();
      } catch (e) {
        onError();
      }
    },
    onerror() {
      return 5000;
    }
  });
}

export default generateCsv;
